import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Rate,
  message,
  Avatar,
  Drawer,
  Descriptions,
  Spin,
  Badge,
} from "antd";
import {
  EyeOutlined,
  CloseOutlined,
  StarFilled,
  UserOutlined,
} from "@ant-design/icons";
import { getAllUserReviews, reviewBulkUpdate } from "../../../api/AdminRequest";

const Reviews = () => {
  const [allReviews, setAllReviews] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [changedReviews, setChangedReviews] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoader(true);
        const { data } = await getAllUserReviews();
        // console.log(data, "data");

        if (data.success === true) {
          setAllReviews(data.allReviews);
        }
      } catch (error) {
        console.error("Failed to fetch reviews:", error);
        message.error("Failed to load reviews");
      } finally {
        setLoader(false);
      }
    };
    fetchReviews();
  }, []);

  const toggleReviewPublishState = (id) => {
    setChangedReviews((prev) => {
      const index = prev.findIndex((r) => r.id === id);
      if (index > -1) {
        return prev.filter((r) => r.id !== id);
      } else {
        const review = allReviews.find((r) => r._id === id);
        return [...prev, { id, publish: !review.publish }];
      }
    });
  };

  const handleSaveChanges = async () => {
    try {
      // console.log(changedReviews, "sasa");

      const { data } = await reviewBulkUpdate(changedReviews);
      // console.log(data, "final answer");

      const updatedReviews = allReviews.map((review) => {
        const changedReview = changedReviews.find((r) => r.id === review._id);
        if (changedReview) {
          return { ...review, publish: changedReview.publish };
        }
        return review;
      });
      setAllReviews(updatedReviews);
      setChangedReviews([]);
      setIsEditMode(false);
      message.success("Changes saved successfully");
    } catch (error) {
      console.error("Failed to save changes:", error);
      message.error("Failed to save changes");
    }
  };

  const handleDiscardChanges = () => {
    setChangedReviews([]);
    setIsEditMode(false);
  };

  const isReviewChanged = (review) => {
    return changedReviews.some((r) => r.id === review._id);
  };

  const showDrawer = (review) => {
    setSelectedReview(review);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setSelectedReview(null);
  };

  const columns = [
    {
      title: "Buyer Name",
      dataIndex: ["userID", "name"],
      key: "name",
      render: (text, record) => (
        <div className="flex items-center">
          <Avatar
            src={record.userID?.profileImg} // Assuming there's an avatar field in userID
            icon={<UserOutlined />} // This will be shown if no src is provided
            className="mr-2"
          />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Product Title",
      dataIndex: ["productID", "productName"],
      key: "productTitle",
      render: (text, record) => (record.productID ? text : "N/A"),
    },
    // {
    //   title: "Category",
    //   dataIndex: ["productID", "category"],
    //   key: "category",
    //   render: (text, record) => (record.productID ? text : "N/A"),
    // },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      render: (rating) => (
        <span className="flex items-center">
          <span>{rating ? `${rating}/5` : "N/A"}</span>
          <StarFilled style={{ color: "#fadb14", marginRight: "4px" }} />
        </span>
      ),
    },
    {
      title: "Review",
      key: "review",
      align:"center",
      render: (_, record) => {
        
        
        if (!isEditMode) return <Button
        icon={<EyeOutlined />}
        className="bg-blue-600 text-white"
        onClick={() => showDrawer(record)}
        />;
      const isChanged = isReviewChanged(record);
      const willBePublished = isChanged
        ? changedReviews.find((r) => r.id === record._id).publish
        : record.publish;
        return(
         
        
          <Button
            onClick={() => toggleReviewPublishState(record._id)}
            type={willBePublished ? "primary" : "default"}
            disabled={!isEditMode}
          >
            {willBePublished
              ? isChanged
                ? "Selected to Publish"
                : "Published"
              : "Select to Publish"}
          </Button>
        
        )
      },
    },

    
  ];

  const publishedReviews = allReviews.filter(
    (review) => review.publish !== isReviewChanged(review)
  );

  const ReviewDrawer = () => (
    <Drawer
      title="Review Details"
      placement="right"
      onClose={closeDrawer}
      visible={drawerVisible}
      width={500}
    >
      {selectedReview && (
        <Descriptions column={1}>
          <Descriptions.Item label="Buyer Name">
            {selectedReview.userID?.name || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {selectedReview.userID?.email || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Phone">
            {selectedReview.userID?.phone || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Product Name">
            {selectedReview.productID?.productName || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Category">
            {selectedReview.productID?.category || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Rating">
            <Rate disabled defaultValue={selectedReview.rating} />
          </Descriptions.Item>
          <Descriptions.Item label="Review Content">
            {selectedReview.content || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Created Date">
            {new Date(selectedReview.createdDate).toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="Publish Status">
            {selectedReview.publish ? "Published" : "Not Published"}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Drawer>
  );

  return (
    <Spin spinning={loader}>
      <div className="p-2">
        <div className="mb-2 flex justify-end">
          <Button
            onClick={() => setIsEditMode(!isEditMode)}
            className="px-8 py-2 text-[12px] font-medium text-white bg-[#1955EB] hover:border-[#1955EB] border-[1px] rounded-md hover:bg-white hover:text-[#1955EB]"
          >
            {isEditMode ? "Cancel" : "Edit"}
          </Button>
        </div>

        <Card
          title={
            <div className="flex gap-2 items-center">
              <span>Testimonials</span>
              <span className="text-gray-500 text-sm">
                {publishedReviews.length} Reviews
              </span>
            </div>
          }
          className="w-full max-w-[1150px]"
          style={{ maxWidth: "1150px", padding: "0" }}
        >
          <div className="h-full overflow-x-auto scrollbar-hide p-4">
            <div className="flex space-x-4 pb-4 h-full">
              {publishedReviews.map((testimonial) => (
                <div key={testimonial._id} className="flex flex-col gap-2">
                  {testimonial?.publish ? (
                    <Badge.Ribbon text="Live" color="green">
                      <Card
                        className="w-[499px] flex-shrink-0 shadow-sm relative"
                        style={{ padding: "12px" }}
                      >
                        {isEditMode && (
                          <Button
                            type="text"
                            icon={<CloseOutlined />}
                            className="absolute top-1 right-1 text-gray-500 hover:text-red-500"
                            onClick={() =>
                              toggleReviewPublishState(testimonial._id)
                            }
                          />
                        )}
                        <p className="mb-2 text-sm line-clamp-4">
                          {testimonial.content}
                        </p>
                      </Card>
                    </Badge.Ribbon>
                  ) : (
                    <Card
                      className="w-[499px] flex-shrink-0 shadow-sm relative"
                      style={{ padding: "12px" }}
                    >
                      {isEditMode && (
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          className="absolute top-1 right-1 text-gray-500 hover:text-red-500"
                          onClick={() =>
                            toggleReviewPublishState(testimonial._id)
                          }
                        />
                      )}
                      <p className="mb-2 text-sm line-clamp-4">
                        {testimonial.content}
                      </p>
                    </Card>
                  )}
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-bold text-sm ">
                        {testimonial.userID?.name}
                      </p>
                      <p className="text-xs text-gray-500 truncate w-32">
                        {testimonial.productID?.productName}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm">
                        {new Date(testimonial.createdDate).toLocaleDateString()}
                      </p>
                      <p className="text-xs text-gray-500">
                        {new Date(testimonial.createdDate).toLocaleTimeString()}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {isEditMode && (
            <div className="flex justify-end mt-4 space-x-2">
              <Button onClick={handleDiscardChanges}>Discard</Button>
              <Button type="primary" onClick={handleSaveChanges}>
                Save Changes
              </Button>
            </div>
          )}
        </Card>

        <div className="mt-6">
          <Table columns={columns} dataSource={allReviews} pagination={false} />
        </div>
        <ReviewDrawer />
      </div>
    </Spin>
  );
};

export default Reviews;
